import { render, staticRenderFns } from "./LaporanIcon.vue?vue&type=template&id=6db244c2"
import script from "./LaporanIcon.vue?vue&type=script&lang=js"
export * from "./LaporanIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports